module.exports = __webpack_public_path__ + "img/mind_template_item_3_5.475cddec.png";